export default "/images/merge-search.png?b017ceec8aac4fe623c3c1a88229fd89";